import { IWidgetOptionValue } from '../../../../Widget';

/**
 * Permette di ottenere degli esempi di valori se non sono stat ancora configurati
 * per non mostrare un elemento vuoto (invisibile) nel preveview del Widget.
 */
export function optionsOrPreviewOptions(
  options: IWidgetOptionValue[] | null | undefined,
  preview: boolean,
): IWidgetOptionValue[] {
  if ((!options || options.length === 0) && preview) {
    return [
      {
        type: 'option',
        label: [{ type: 'text', text: 'Nessuna opzione aggiunta' }],
        value: '1',
      },
      {
        type: 'option',
        label: [{ type: 'text', text: 'Altro esempio di opzione' }],
        value: '2',
      },
    ];
  }

  return options ?? [];
}
